"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function CardText(props) {
    var className = props.className, style = props.style, cardList = props.cardList, isTwo = props.isTwo;
    var _a = (0, react_1.useState)(0), len = _a[0], setLen = _a[1];
    var _b = (0, react_1.useState)(false), isThree = _b[0], setIsThree = _b[1];
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    (0, react_1.useEffect)(function () {
        if (cardList === null || cardList === void 0 ? void 0 : cardList.length) {
            var flag = cardList.length % 3 === 0;
            setLen(cardList.length);
            setIsThree(!isTwo && flag);
        }
    }, cardList);
    var Article = function (props) {
        var titleRef = (0, react_1.useRef)(null);
        var descRef = (0, react_1.useRef)(null);
        (0, react_1.useEffect)(function () {
            if ((titleRef === null || titleRef === void 0 ? void 0 : titleRef.current) && (descRef === null || descRef === void 0 ? void 0 : descRef.current)) {
                var titleDom = titleRef === null || titleRef === void 0 ? void 0 : titleRef.current;
                var descDom = descRef === null || descRef === void 0 ? void 0 : descRef.current;
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                descDom.style['-webkit-line-clamp'] = (titleDom.clientHeight > 25 && isThree) ? '3' : '4';
            }
        }, []);
        var subTitle = props.subTitle, title = props.title, description = props.description, bottomLeftText = props.bottomLeftText, bottomRightUrl = props.bottomRightUrl, bottomRightText = props.bottomRightText, extendProps = props.extendProps, isThree = props.isThree;
        return (react_1.default.createElement("div", { className: "card-text-list-container" },
            react_1.default.createElement("div", { className: "card-text-list-container-flex" },
                react_1.default.createElement("div", { className: "card-text-list" },
                    react_1.default.createElement("div", { className: "card-text-list-subtitle" }, subTitle),
                    react_1.default.createElement("div", { className: "card-text-list-title", ref: titleRef }, title),
                    react_1.default.createElement("div", { className: "card-text-list-description", ref: descRef }, description),
                    react_1.default.createElement("div", { className: "card-text-list-bottom" },
                        react_1.default.createElement("div", { className: "card-text-list-bottom-tips" }, bottomLeftText),
                        react_1.default.createElement("div", { className: "card-text-list-bottom-click" },
                            react_1.default.createElement("a", __assign({ href: bottomRightUrl }, (extendProps || {})), bottomRightText)))))));
    };
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-card-text"), className) }, cardList === null || cardList === void 0 ? void 0 :
        cardList.map(function (o, index) {
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-card"), { 'three-line': isThree, 'two-line': !isThree }), key: index },
                react_1.default.createElement(Article, __assign({}, o, { isThree: isThree }))));
        }),
        len > 0 && !isThree && len % 2 === 1 ? react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-card"), 'two-line', 'empty-none') }) : react_1.default.createElement(react_1.default.Fragment, null)));
}
CardText.displayName = 'CardText';
exports.default = CardText;
//# sourceMappingURL=CardText.js.map